document.addEventListener('DOMContentLoaded', function() {
  const marqueeSections = document.querySelectorAll('.logo-marquee-section');

  marqueeSections.forEach(section => {
    const marqueeContent = section.querySelector('.marquee-content');
    if (marqueeContent) {
      section.addEventListener('mouseenter', () => {
        marqueeContent.style.animationPlayState = 'paused';
      });

      section.addEventListener('mouseleave', () => {
        marqueeContent.style.animationPlayState = 'running';
      });
    }
  });
}); 